"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventArgs = /** @class */ (function () {
    function EventArgs(payload) {
        this.payload = payload;
    }
    return EventArgs;
}());
exports.default = EventArgs;
//# sourceMappingURL=EventArgs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/models/EventArgs.js
// module id = 429
// module chunks = 8